import initialState from 'redux/initialState'
import { applyMiddleware, compose, createStore } from 'redux' // { object within object } anything from parameter/function/object
import rootReducer from 'redux/actionsAndReducers/reducers'
import logger from 'redux-logger'                             // Logging every action and state change
import thunk from 'redux-thunk'                               // Checkout https://github.com/gaearon/redux-thunk

import { routerMiddleware } from 'connected-react-router'
import { createBrowserHistory } from 'history'

//#region REDUX PERSIST 
import { persistStore, persistReducer } from 'redux-persist'
// import { createFilter } from 'redux-persist-transform-filter'
// import storage from 'redux-persist/lib/storage'
import storage from 'redux-persist/lib/storage/session'
import handleStorage from 'redux/store/handleStorage'


// Config/Transforms
// const saveSubsetFilter = createFilter(
//   'IVAR',
//   ['sysUser', 'routing', 'aggregates']
// )

// Config
const persistConfig = {
  // version: 0, // Storge version. Update this to trigger migration. Should be done if state structure is modified or extended.
  key: 'ivarDoc-root',
  storage,
  whitelist: ['userSettings', 'oidc', 'IVAR', 'accessRights'], // Exclude connected-react-router from whitelist (or include in blacklist). Will otherwise reset authorization code #code=XXXX in url on return from IVAR Login service.
  // transforms: [saveSubsetFilter]
}
handleStorage.onExpiredTokens('sessionStorage', persistConfig) // First argument: 'localStorage' or 'sessionStorage'.
//#endregion

const history = createBrowserHistory()

// MIDDLEWARE //////////////////////////////
let middlewares = []
middlewares.push(thunk)
middlewares.push(routerMiddleware(history)) // for dispatching history actions
if (process.env.NODE_ENV !== 'production') {
  middlewares.push(logger)
}

// Implement Redux DevTools extention in Chrome if possible.
const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose // Enabling Redux DevTools. Use only compose if redux dev tools shoudl be disabled.

const persistedReducer = persistReducer(persistConfig, rootReducer(history)) // Wrapping rootReducer(history) in persistReducer to create persistedReducer.

const store = createStore(
    persistedReducer, // replacing rootReducer(history) when using redux-persist.
    initialState,
    composeEnhancer(
        applyMiddleware(...middlewares), // apply applies array elements from middlewares as functionarguments in applyMiddleware. E.g. applyMiddleware(thunk, routerMiddleware(history), logger)
    )
)
    //#region - Hot Module Replacement implementation according to https://medium.com/@brianhan/hot-reloading-cra-without-eject-b54af352c642
    if(process.env.NODE_ENV !== 'production'){ // Dev modefFeature toggle
          if (module.hot) {
            module.hot.accept(persistedReducer, () => {
              store.replaceReducer(persistedReducer)
            })
          }
    }
    //#endregion



const persistor = persistStore(store)
export {store, history, persistor}
